import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Import React Flow styles once globally (required only once at the app root)
import 'reactflow/dist/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import { ReactFlowProvider } from "reactflow";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ReactFlowProvider>
    <App />
  </ReactFlowProvider>
);


reportWebVitals();
